import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useProfile } from '../context/ProfileContext';
import axios from 'axios';
import './Mymatches.css';
 
const Match4Ka100 = () => {
  const { matchId } = useParams();
  const { profile } = useProfile();
  const navigate = useNavigate();
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userId = profile.userId;

  useEffect(() => {
    const fetchMatches = async () => {
      try {
        setLoading(true);
        console.log('Fetching 4Ka100 matches for matchId:', matchId, 'and userId:', userId);
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/matches/${userId}`);
        console.log('Fetched all matches:', response.data);
        
        // Filter matches by matchId and get all matches (upcoming, live, completed)
        const allMatches = [
          ...(response.data.upcoming || []),
          ...(response.data.live || []),
          ...(response.data.completed || [])
        ];
        
        // Debug: Log all betTypes to see what we're working with
        console.log('All betTypes found:', [...new Set(allMatches.map(match => match.betType))]);
        console.log('All matches for matchId:', matchId, allMatches.filter(match => match.matchId === matchId));
        
        // Filter STRICTLY by both matchId and betType for 4Ka100 only
        const filteredMatches = allMatches.filter(match => {
          const matchesId = match.matchId === matchId;
          const betType = match.betType ? match.betType.trim() : '';
          
          // More strict matching for 4Ka100
          const is4Ka100 = betType === '4Ka100' || 
                           betType === '4ka100' || 
                           betType === '4KA100' || 
                           betType === '4K100' ||
                           betType === '4k100';
          
          console.log(`Match ID: ${match.id}, MatchId: ${match.matchId}, BetType: "${match.betType}", Is4Ka100: ${is4Ka100}`);
          return matchesId && is4Ka100;
        });
        
        // NO FALLBACK - Show only 4Ka100 matches or empty if none exist
        console.log('Filtered 4Ka100 matches:', filteredMatches);
        setMatches(filteredMatches);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching 4Ka100 matches:', err);
        setError('Failed to load matches. Please try again later.');
        setLoading(false);
      }
    };

    if (userId && matchId) {
      fetchMatches();
    }
  }, [userId, matchId]);

  const handleMatchClick = (match) => {
    console.log('Navigating to match detail for ID:', match.id);
    navigate(`/match-detail/${match.id}`);
  };

  const getBadgeClass = (status) => {
    if (status === 'live') return 'badge-live';
    if (status === 'upcoming' || status === 'upcomming') return 'badge-upcoming';
    if (status === 'completed' || status === 'complete') return 'badge-completed';
    return '';
  };

  const renderMatchesList = () => {
    if (loading) {
      return <div className="mymatches-loading">Loading 4Ka100 matches...</div>;
    }

    if (error) {
      return <div className="mymatches-error">{error}</div>;
    }

    if (!matches || matches.length === 0) {
      return (
        <div className="mymatches-no-matches">
          <p>No 4Ka100 bets available for this match</p>
          <p style={{ fontSize: '14px', color: '#ccc', marginTop: '10px' }}>
            You haven't placed any 4Ka100 bets for this game yet.
          </p>
        </div>
      );
    }

    return matches.map((match, index) => (
      <div 
        className="mymatches-card" 
        key={match.id || index}
        onClick={() => handleMatchClick(match)}
      >
        <div className="mymatches-match">
          <div className="mymatches-team mymatches-team-left">
            {match.team1}
          </div>
          <div className="mymatches-score-container">
            <div className="mymatches-score">
              {match.score}
              <div className="mymatches-time">{match.time}</div>
            </div>
          </div>
          <div className="mymatches-team mymatches-team-right">
            {match.team2}
          </div>
          <div className={`mymatches-live-badge ${getBadgeClass(match.status)}`}>
            {match.status}
          </div>
        </div>
        <div
  className="mymatches-joined-info"
  style={{
    backgroundColor: match.result === 'win' ? 'lightgreen' : match.result === 'loss' ? '#ffcccc' : 'transparent',
  }}
>
  <span>
    {match.contestsJoined} Questions • ₹{match.amount} • {match.betType}
  </span>

  {match.profit > 0 && (
    <span className="mymatches-profit">
      {match.result}: ₹{match.profit}
    </span>
  )}
</div>

      </div>
    ));
  };

  return (
    <div className="mymatches-page">
      {/* Header Section */}
      <header className="header">
        <div className="header-left">
          <button 
            className="back-button"
            onClick={() => navigate(-1)}
            style={{
              background: 'none',
              border: 'none',
              color: 'white',
              fontSize: '18px',
              cursor: 'pointer',
              marginRight: '10px'
            }}
          >
            ←
          </button>
          <h1 className="site-title" onClick={() => navigate('/')}>CricWhizz</h1>
        </div>
        <div className="header-right">
          <div className="wallet-button">
            <span className="wallet-icon">💰</span>
            <span className="wallet-amount">{profile.walletBalance}</span>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="mymatches-content">
        <div className="mymatches-container">
          <div className="mymatches-page-title">
            <h2 style={{ color: 'white', textAlign: 'center', margin: '20px 0' }}>
              4Ka100 Matches
            </h2>
          </div>

          <div className="mymatches-list">
            {renderMatchesList()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Match4Ka100; 
